/**
 * @param {any} draft - Draft state.
 * @param {any} payload - Action payload.
 */
export const setRequest = (draft, payload) => {
    draft.requests = [...draft.requests, payload];
};
